import * as React from 'react'
import { SubscriptionDiscountLabel } from '@components/labels/subscription-contract/subscription-discount-label'

export const ApartmentCardLabels = (): JSX.Element => (
  <div className="apartment-card__label">
    <SubscriptionDiscountLabel />
  </div>
)
